import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';
import { AuthService } from 'src/app/authentication/auth.service';
import { PreciosOrdenesFisicasService } from 'src/app/services/empresa/precios-ordenes-fisicas.service';
import { SolicitudesOrdenesFisicasService } from 'src/app/services/empresa/solicitudes-ordenes-fisicas.service';

@Component({
    selector: 'app-ordenes-fisicas-nueva-solicitud',
    templateUrl: './ordenes-fisicas-nueva-solicitud.component.html',
    styleUrls: ['./ordenes-fisicas-nueva-solicitud.component.scss'],
    standalone: false
})
export class OrdenesFisicasNuevaSolicitudComponent implements OnInit {

  public cargandoInicial = false;
  public generandoBlocks = false;
  public guardandoSolicitud = false;

  public totalGenerar: number | null = null;
  public tipoPrecio = '';
  public proveedorTemporal = '';
  public prefijoSecuencia = '';

  public tipoPrecios: any[] = [];
  public proveedores: any[] = [];
  public prefijosSecuenciales: any[] = [];
  public proveedoresSeleccionados: any[] = [];
  public preciosDisponibles: any[] = [];

  public secuencialSolicitud = 1;
  public secuencialBlock = 0;
  public secuencialTalonario = 100;
  public responsable = '';

  public blocksGenerados: any[] = [];
  public detallePrecios2D: Array<{ numeroBlocks: number | null; precios2D: string }> = [];

  constructor(
    private solicitudesOrdenesFisicasService: SolicitudesOrdenesFisicasService,
    private preciosOrdenesFisicasService: PreciosOrdenesFisicasService,
    private authService: AuthService,
    private toastr: ToastrService,
    private router: Router
  ) { }

  ngOnInit(): void {
    this.responsable = this.authService.loginUsuario.nombre || '';
    this.cargarInicializacion();
  }

  get totalBlocksGenerados(): number {
    return this.blocksGenerados.length;
  }

  get totalBlocksAsignados(): number {
    return this.detallePrecios2D.reduce((acumulado, item) => {
      return acumulado + Number(item.numeroBlocks || 0);
    }, 0);
  }

  get totalBlocksDisponibles(): number {
    return Math.max(this.totalBlocksGenerados - this.totalBlocksAsignados, 0);
  }

  get porcentajeAsignacion(): number {
    if (this.totalBlocksGenerados <= 0) {
      return 0;
    }

    return Math.min(100, Math.round((this.totalBlocksAsignados / this.totalBlocksGenerados) * 100));
  }

  get secuencialVisible(): string {
    if (!this.prefijoSecuencia) {
      return String(this.secuencialTalonario);
    }

    return `${this.prefijoSecuencia}${this.secuencialTalonario}`;
  }

  cargarInicializacion() {
    this.cargandoInicial = true;

    this.solicitudesOrdenesFisicasService.obtenerInicializacion(localStorage.getItem('token') || '').subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        const data = rows[0] || {};

        this.tipoPrecios = data.tipoPrecios ?? [];
        this.proveedores = data.proveedores ?? [];
        this.prefijosSecuenciales = data.prefijosSecuenciales ?? [];
        this.secuencialSolicitud = Number(data.secuencialSolicitud ?? 1) || 1;
        this.secuencialBlock = Number(data.secuencialBlock ?? 0) || 0;
        this.cargandoInicial = false;

        if (this.prefijosSecuenciales.length > 0) {
          const prefijoActualExiste = this.prefijosSecuenciales.some((item: any) => String(item.start) === this.prefijoSecuencia);
          this.prefijoSecuencia = prefijoActualExiste
            ? this.prefijoSecuencia
            : String(this.prefijosSecuenciales[0].start || '');

          if (this.prefijoSecuencia) {
            this.cargarSiguienteSecuencia();
          }
        } else {
          this.prefijoSecuencia = '';
          this.secuencialTalonario = 100;
        }
      },
      error: () => {
        this.cargandoInicial = false;
        this.toastr.error('No se pudo cargar la información inicial.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  cargarSiguienteSecuencia() {
    if (!this.prefijoSecuencia) {
      this.secuencialTalonario = 100;
      return;
    }

    this.solicitudesOrdenesFisicasService.obtenerSiguienteSecuencia(
      localStorage.getItem('token') || '',
      this.prefijoSecuencia
    ).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        const data = rows[0] || {};
        this.secuencialTalonario = Number(data.siguienteNumero ?? 100) || 100;
      },
      error: () => { this.secuencialTalonario = 100; }
    });
  }

  onPrefijoChange() {
    this.blocksGenerados = [];
    this.detallePrecios2D = [];
    this.cargarSiguienteSecuencia();
  }

  onTipoPrecioChange() {
    this.preciosDisponibles = [];
    this.detallePrecios2D = [];

    if (!this.tipoPrecio) {
      return;
    }

    this.preciosOrdenesFisicasService.listarPreciosPorTipo(localStorage.getItem('token') || '', this.tipoPrecio).subscribe({
      next: (resp: any) => {
        this.preciosDisponibles = Array.isArray(resp) ? resp : resp?.rows ?? resp?.data ?? [];

        if (this.blocksGenerados.length > 0) {
          this.detallePrecios2D = [{ numeroBlocks: null, precios2D: '' }];
        }
      },
      error: () => { this.preciosDisponibles = []; }
    });
  }

  agregarProveedor(): boolean {
    if (!this.proveedorTemporal) {
      return false;
    }

    const proveedor = this.proveedores.find((item: any) => String(item.COD_PROV) === String(this.proveedorTemporal));

    if (!proveedor) {
      return false;
    }

    const existe = this.proveedoresSeleccionados.some((item: any) => String(item.COD_PROV) === String(proveedor.COD_PROV));
    if (existe) {
      this.toastr.info('Este proveedor ya fue agregado.', 'Atención', {
        timeOut: 2500,
        closeButton: true,
        progressBar: true
      });
      this.proveedorTemporal = '';
      return true;
    }

    this.proveedoresSeleccionados.push(proveedor);
    this.proveedorTemporal = '';
    return true;
  }

  removerProveedor(indice: number) {
    this.proveedoresSeleccionados.splice(indice, 1);
  }

  crearBlocks() {
    const total = Number(this.totalGenerar || 0);

    if (total < 25) {
      this.toastr.info('Para generar la solicitud mínimo deben ser 25 órdenes.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (total % 25 !== 0) {
      this.toastr.info('El número ingresado no es múltiplo de 25.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (!this.tipoPrecio) {
      this.toastr.info('Seleccione un tipo de precio.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (!this.prefijoSecuencia) {
      this.toastr.info('Seleccione un prefijo secuencial.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.generandoBlocks = true;

    this.solicitudesOrdenesFisicasService.generarBlocksConPrefijo(
      localStorage.getItem('token') || '',
      total,
      this.prefijoSecuencia,
      this.secuencialTalonario,
      this.secuencialBlock
    ).subscribe({
      next: (resp: any) => {
        const rows = Array.isArray(resp) ? resp : resp?.rows ?? [];
        this.blocksGenerados = rows;
        this.generandoBlocks = false;

        if (this.blocksGenerados.length === 0) {
          this.toastr.error('No se pudieron generar los blocks.', 'Atención', {
            timeOut: 3000,
            closeButton: true,
            progressBar: true
          });
          return;
        }

        this.detallePrecios2D = [{ numeroBlocks: null, precios2D: '' }];

        this.toastr.success('Blocks generados correctamente.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });
      },
      error: (err: any) => {
        this.generandoBlocks = false;
        this.blocksGenerados = [];
        this.toastr.error(err?.error?.message || 'No se pudieron generar los blocks.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  async agregarPrefijoSecuencial() {
    const result = await Swal.fire({
      title: 'Agregar prefijo',
      input: 'text',
      inputLabel: 'Ingrese la letra o inicial del secuencial',
      inputPlaceholder: 'Ejemplo: A, B, C',
      showCancelButton: true,
      confirmButtonText: 'Guardar',
      cancelButtonText: 'Cancelar',
      inputValidator: (value) => {
        const prefijo = String(value || '').trim().toUpperCase();

        if (!prefijo) {
          return 'Ingrese un prefijo';
        }

        if (prefijo.length > 5) {
          return 'El prefijo debe tener máximo 5 caracteres';
        }

        return null;
      }
    });

    if (!result.isConfirmed) {
      return;
    }

    const prefijo = String(result.value || '').trim().toUpperCase();

    this.solicitudesOrdenesFisicasService.crearPrefijoSecuencial(localStorage.getItem('token') || '', prefijo).subscribe({
      next: () => {
        this.toastr.success('Prefijo agregado correctamente.', 'Atención', {
          timeOut: 2500,
          closeButton: true,
          progressBar: true
        });

        this.prefijoSecuencia = prefijo;
        this.cargarInicializacion();
      },
      error: (err: any) => {
        this.toastr.error(err?.error?.message || 'No se pudo agregar el prefijo.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  agregarDetalleOrden() {
    const tienePendientes = this.detallePrecios2D.some((item) => !item.numeroBlocks || !item.precios2D);

    if (tienePendientes) {
      this.toastr.info('Complete los items actuales antes de agregar otro.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (this.totalBlocksDisponibles <= 0) {
      this.toastr.info('No hay blocks disponibles para agregar otro item.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    this.detallePrecios2D.push({ numeroBlocks: null, precios2D: '' });
  }

  eliminarDetalleOrden(indice: number) {
    this.detallePrecios2D.splice(indice, 1);
  }

  validarNumeroBlocks(indice: number) {
    const item = this.detallePrecios2D[indice];

    if (!item || item.numeroBlocks === null || item.numeroBlocks === undefined) {
      return;
    }

    if (Number(item.numeroBlocks) <= 0) {
      item.numeroBlocks = null;
      return;
    }

    if (this.totalBlocksAsignados > this.totalBlocksGenerados) {
      item.numeroBlocks = null;
      this.toastr.info('El valor ingresado supera el total de blocks disponibles.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
    }
  }

  async guardarSolicitud() {
    if (this.proveedorTemporal) {
      this.agregarProveedor();
    }

    if (this.blocksGenerados.length === 0) {
      this.toastr.info('Primero debe generar los blocks.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (this.proveedoresSeleccionados.length === 0) {
      this.toastr.info('Seleccione al menos un proveedor.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (!this.prefijoSecuencia) {
      this.toastr.info('Seleccione un prefijo secuencial.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    const tienePendientes = this.detallePrecios2D.some((item) => !item.numeroBlocks || !item.precios2D);
    if (tienePendientes) {
      this.toastr.info('No puede guardar mientras existan items sin completar.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    if (this.totalBlocksDisponibles > 0) {
      this.toastr.info('Aún faltan blocks por asignar.', 'Atención', {
        timeOut: 3000,
        closeButton: true,
        progressBar: true
      });
      return;
    }

    const confirmacion = await Swal.fire({
      icon: 'warning',
      title: '¿Guardar solicitud?',
      text: 'Se registrará la solicitud de órdenes físicas con su detalle actual.',
      showCancelButton: true,
      confirmButtonColor: '#6259ca',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmacion.isConfirmed) {
      return;
    }

    this.guardandoSolicitud = true;

    this.solicitudesOrdenesFisicasService.crearSolicitud({
      token: localStorage.getItem('token') || '',
      totalTalonarios: Number(this.totalGenerar || 0),
      secuencia: this.secuencialTalonario,
      prefijoSecuencia: this.prefijoSecuencia,
      tablaAsignacionBlocks: this.blocksGenerados,
      responsable: this.responsable,
      proveedores: this.proveedoresSeleccionados,
      tipoPrecio: this.tipoPrecio,
      detallePrecios2D: this.detallePrecios2D.map((item) => ({
        numeroBlocks: Number(item.numeroBlocks),
        precios2D: Number(item.precios2D)
      }))
    }).subscribe({
      next: () => {
        this.guardandoSolicitud = false;
        this.toastr.success('Solicitud registrada correctamente.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
        this.router.navigate(['/sistema/ordenes-fisicas-solicitudes']);
      },
      error: (err: any) => {
        this.guardandoSolicitud = false;
        this.toastr.error(err?.error?.message || 'No se pudo registrar la solicitud.', 'Atención', {
          timeOut: 3000,
          closeButton: true,
          progressBar: true
        });
      }
    });
  }

  limpiarPantalla() {
    this.totalGenerar = null;
    this.tipoPrecio = '';
    this.proveedorTemporal = '';
    this.prefijoSecuencia = '';
    this.proveedoresSeleccionados = [];
    this.preciosDisponibles = [];
    this.blocksGenerados = [];
    this.detallePrecios2D = [];
    this.cargarInicializacion();
  }
}
